import axios from "../axios";
import errorHandler from "../error-handler";
import * as uploadActions from "./upload";

export const getTaxYearList = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getTaxYear = (year) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/${year}`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const updateTaxYear = (year, data) =>
    new Promise((resolve, reject) =>
        axios
            .put(`/tax_year/${year}`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const createTaxYear = (year) =>
    new Promise((resolve, reject) =>
        axios
            .post(`/tax_year`, {
                year: year
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const uploadTaxFile = (year, file, progressCallback) => {
    return uploadActions.upload(file, `/tax_year/${year}/files`, null, null, progressCallback);
};

export const getTaxYearDataStatus = (year) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/${year}/data_status`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const resetTaxYearData = (year) =>
    new Promise((resolve, reject) =>
        axios
            .post(`/tax_year/${year}/reset`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const importTaxFile = (data) =>
    new Promise((resolve, reject) =>
        axios
            .post(`/tax_year/import`, data)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const deleteTaxFile = (year, fileId) =>
    new Promise((resolve, reject) =>
        axios
            .delete(`/tax_year/${year}/files/${fileId}`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getImportStatus = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/import/status`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getImportLog = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/import/log`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getImportHistory = (year, page, size) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/import/history`, {
                params: {
                    year: year,
                    page,
                    size
                }
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const getImportEntryLog = (fileImportId) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/import/${fileImportId}/log`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const abortImport = () =>
    new Promise((resolve, reject) =>
        axios
            .post(`/tax_year/import/abort`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );
